import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import {
  getCurrentStoreViewStatus,
  getSelectedStore,
  getSocialAuth,
} from '../+state/stores.selectors';
import { CustomerAuthService } from '../../customer-auth.service';
import { LocationService } from '../../location.service';

@Component({
  selector: 'app-store-customer-login',
  templateUrl: './store-customer-login.component.html',
  styleUrls: ['./store-customer-login.component.scss'],
})
export class StoreCustomerLoginComponent implements OnInit, OnDestroy {
  unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private store: Store,
    private router: Router,
    private locationService: LocationService,
    public customerAuthService: CustomerAuthService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.store.select(getSelectedStore),
      this.store.select(getCurrentStoreViewStatus),
      this.store.select(getSocialAuth),
    ])
      .pipe(
        takeUntil(this.unsubscribe$),
        filter(([store, status]) => !!store?.id && status.state === 'LOGIN'),
      )
      .subscribe(() => {
        if (
          this.customerAuthService.isUserLoggedIn() ||
          !this.customerAuthService.enableCustomerAuth()
        ) {
          const next = this.route.snapshot.queryParamMap.get('next') || '';
          this.router.navigateByUrl(this.locationService.base_url(next));
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
